import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const visitorId = () => {
  let id = localStorage.getItem("mystic_visitor");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("mystic_visitor", id);
  }
  return id;
};

const sent = new Set();

export const trackVisit = (event) => {
  if (event === "open") {
    if (sent.has(event)) return;
    sent.add(event);
  }
  try {
    axios.post(`${API}/track`, { event, visitor_id: visitorId() }).catch(() => {});
  } catch { /* tracking must never break the page */ }
};
